import React, { useState } from "react";
import { Box } from "@mui/material";
import { mockEmployeeDetailsData } from "../../mockData/employee-details.data";
import { EmployeeDetailsData } from "../../types/employee-details";
import OnTimeRatio from "./components/OnTimeRatio";
import ProfileCard from "./components/ProfileCard";
import PunctualityTrend from "./components/PunctualityTrend";
import PScoreHeatMap from "./components/PScoreHeatMap";

const EmployeeProfilePage: React.FC = () => {
  const [employeeData] = useState<EmployeeDetailsData>(
    mockEmployeeDetailsData
  );

  return (
    <Box sx={{ px:0, py: 0, minHeight: "100dvh", }}>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "1fr", sm: "1fr",lg: "7fr 3fr" }}
        alignItems="start"
        minHeight="100%"
        gap={2}
      >
        {/* Left Column  */}
        <Box display="flex" flexDirection="column" minWidth={0} gap={2}>
          <PScoreHeatMap
            pScore={employeeData.profile.pScore}
            heatmapData={employeeData.heatmapData}
          />
          <PunctualityTrend
          // punctualityData={employeeData.punctualityData}
          // pScore={employeeData.profile.pScore}
          // trendAlert={employeeData.trendAlert}
          />
        </Box>

        {/* Right Column  */}
        <Box display="flex" flexDirection="column" gap={2} minWidth={0} height="100%">
          <ProfileCard profile={employeeData.profile} />
          <Box sx={{ flexGrow: 1 }}>
            <OnTimeRatio
              onTime={employeeData.onTimeRatio.onTime}
              late={employeeData.onTimeRatio.late}
              didNotCome={employeeData.onTimeRatio.didNotCome}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeProfilePage;
